<template>
  <filter-template
    @submit="filter()"
    @clear="clearFilter()"
  >
    <v-container class="pa-0">
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          ma-2
        >
          <div class="headerSubtitle1">
            Filtros da listagem
          </div>
        </v-flex>
        <v-flex>
          <input-select
            v-model="payload.status"
            item-text="text"
            item-value="value"
            :items="status"
            :label="'Selecione'"
            :return-object="false"
            multiple
            clearable
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataInicial"
            :rules="[dateLesserThan(payload.dataFinal)]"
            :label="$t('support.components.reports.initialDate')"
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataFinal"
            :rules="[dateGreaterThan(payload.dataInicial)]"
            :label="$t('support.components.reports.finalDate')"
          />
        </v-flex>
        <v-flex>
          <input-text-area
            v-model="payload.clienteIds"
            :rules="[onlyNumbersCommaSpace()]"
            label="Informe aqui um ou mais id(s) de clientes, separados por vírgulas"
            :rows="5"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </filter-template>
</template>

<script>
import FilterMixin from 'Support/mixins/FilterMixin';
import rulesMixin from 'Support/mixins/rules-mixin';
import FilterTemplate from 'Support/components/filter-component/FilterTemplate.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import communicationStatus from './communicationStatus';

export default {
  name: 'CommunicationFilter',
  components: {
    FilterTemplate, InputSelect, DatePicker, InputTextArea,
  },
  mixins: [FilterMixin, rulesMixin],
  data: () => ({
    payload: {
      clienteIds: '',
      dataFinal: '',
      dataInicial: '',
      status: [],
    },
    status: [],
  }),
  created() {
    this.setStatusByPage();
  },
  methods: {
    prepareFilter() {
      const { status, ...rest } = this.payload;
      return {
        ...rest,
        status: status.join(','),
      };
    },
    setStatusByPage() {
      const [pending, draft, sended, schedule] = communicationStatus;

      if (this.includes('draft')) {
        this.setStatus(
          pending,
          draft,
        );
      }

      if (this.includes('logs')) {
        this.setStatus(
          sended,
          schedule,
        );
      }
    },
    includes(path) {
      return this.$route.path.includes(path);
    },
    setStatus(...status) {
      this.status.push(
        ...status,
      );
      this.payload.status.push(
        ...status.map(
          s => s.value,
        ),
      );
    },
  },
};
</script>
